import React, { useEffect } from "react";

export default function WebappNavigation(props) {

    const x = props.x;
	const renderCount = React.useRef(1);

	useEffect(() => {
		if (renderCount.current === 1) {

			// Zeiger auf Funktionen
			props.childRendered();			
		}
		renderCount.current++;
	});

	x.wan.init = init;
	x.wan.hideAll = hideAll;

	function init(id) {
		if (typeof x.wan[id] == 'undefined') {
			x.wan[id] = {};
			x.wan[id].hide = () => {};
			x.wan[id].init = () => {};
			x.wan[id].show = () => {};
			x.wan[id].makeMenu = () => {};
		}
	}

	function hideAll() {
		x.was.setModal(false);
		for (const key in x.wan) {
			if (typeof x.wan[key].hide != 'undefined') {
				x.wan[key].hide();
			}
		}

	}
	
	return (
		<React.Fragment />
	);

}

